export const PACKAGE_NAME = 'jiraRovoVideoModal';
export const TEAM_NAME = 'growth-luna';

export const API_FAIL = 'failed';
export const SUBJECT_FEATURE_GATE_ID = 'jiraRovoVideoModalFeature';

export const ROVO_LOOM_VIDEO =
	'https://www.loom.com/embed/87b5573116d344d3a290d6f79c291176?sid=11dca929-28b0-4405-8421-fe63bb25153e';
